// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","disabled":"Button_disabled__1f6YP"};